const styles = {
  imageGrid: {
    width: 60,
    height: 60,
  },
  tab: {
    minHeight: 36,
    '& .MuiTab-root': {
      minHeight: 36,
      padding: '6px 12px',
    },
  },
  tabIcon: {
    fontSize: 18,
  },
  card: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: { xs: '60vh', md: 'auto' },
  },
  gridInfo: {
    maxHeight: { xs: 'auto', md: '80vh' },
    overflowY: 'auto',
    p: 1,
  },
};

export default styles;
